import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ProductService } from '../_services/product.service';
import { ShopDto } from '../profile/shop-dto';
import { FormBuilder, UntypedFormGroup, FormArray, UntypedFormControl } from '@angular/forms';
import { CategoryService } from '../_services/category.service';
@Component({
    selector: 'app-product-detail',
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.css'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class ProductDetailComponent implements OnInit {
  id: number;
  productname: string;
  categories: any = [];
  private sub: any;
  productCategory: number;
  public product: ShopDto;
  form: UntypedFormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private productService: ProductService,
    private categoryService: CategoryService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['productId'];

      this.productService.getProduct(this.id).subscribe(
        data => {
          this.product = JSON.parse(data);
          this.productname = this.product.name;
          this.productCategory = this.product.category_id;
          this.cdr.detectChanges();
        },
        err => {
          console.error('Er is een fout opgetreden');
        }
      );
      this.categoryService.getCategories().subscribe(
        data => {
          this.categories = JSON.parse(data);
          this.cdr.detectChanges();
        },
        err => {
          console.error('Er is een fout opgetreden');
        }
      );
    });
  }

  deleteProduct(id): void {
    this.productService.deleteProduct(id).subscribe(
      data => {
        this.router.navigate(['/profile', { 'showWinkel': true }]);
      },
      err => {
        console.error('Er is iets fout gegaan');
      }
    );
  }

  update(selectedId) {
    this.productService.updateProduct(this.id, selectedId).subscribe(data => {
      this.product = JSON.parse(data);
      this.cdr.detectChanges();
    });
  }
}
